module.exports = __webpack_public_path__ + "static/img/jyphong.b52ed0d7.png";